/**
 * CLC TA API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const JobRunStatus = {
    Running: 'Running',
    Success: 'Success',
    Failed: 'Failed',
    Interrupted: 'Interrupted',
    NeverRun: 'NeverRun'
} as const;
export type JobRunStatus = typeof JobRunStatus[keyof typeof JobRunStatus];

